export default {
    formId: 'editUsersPemissionsForm', //'editUsersPemissionsForm',
    formField: {
      usersPemissionsEdit: {
        name: 'usersPemissionsEdit',
        label: 'Nombre area*',
        requiredErrorMsg: 'El nombre area es requerido.'
      },
    }
};
  